import { Link, useLocation } from "react-router-dom";
import React from "react";
import { FaHome } from "react-icons/fa";
import { GrFormNext } from "react-icons/gr";
import heroVideo from "../assets/hero-video.mp4";
import { useTranslation } from "react-i18next";

interface HeroBannerProps {
  text: string;
}

const HeroBanner: React.FC<HeroBannerProps> = ({ text }) => {
  const location = useLocation();
  const { t } = useTranslation();
  const pathSegments = location.pathname
    .split("/")
    .filter((segment) => segment && !segment.startsWith("p="));

  const breadcrumbs = [];
  breadcrumbs.push({
    label: "home",
    path: "/",
  });

  // Process segments and create breadcrumb items
  pathSegments.forEach((segment, index) => {
    const path = `/${pathSegments.slice(0, index + 1).join("/")}`;
    const formattedSegment = segment.replace(/-/g, " ");
    breadcrumbs.push({
      label: formattedSegment,
      path: path,
    });
  });

  return (
    <section className="relative flex flex-col items-center justify-center w-full min-h-[60vh] px-[5%] overflow-hidden">
      <video
        className="absolute top-0 left-0 w-full h-full object-cover z-[-1]"
        src={heroVideo}
        autoPlay
        loop
        muted
        playsInline
      />

      {/* Overlay */}
      <div
        className="absolute top-0 left-0 w-[70%] semi:w-2/5 h-full z-[-1]"
        style={{
          background: `linear-gradient(to bottom, rgba(5,15,25,0.85), rgba(5,15,25,0.75), rgba(5,15,25,0.85))`,
          clipPath: "polygon(0 0, 90% 0, 100% 50%, 90% 100%, 0% 100%)",
        }}
      />

      <div className="flex flex-col w-full text-white maxContainer">
        <div className="flex flex-col w-[70%] pr-5 py-16 mt-8 semi:w-2/5">
          <h2 className="mb-2 text-sm font-semibold capitalize sm:text-lg">
            {text ||
              t(
                `navTranslate.${breadcrumbs[breadcrumbs.length - 1].label}`
              )}{" "}
          </h2>

          <ol className="list-none p-0 flex-wrap gap-4 flex text-[14px] sm:text-base">
            {breadcrumbs.map((item, index) => (
              <li key={index} className="flex items-center">
                <Link
                  to={item.path}
                  className={`flex flex-nowrap items-center capitalize gap-2 ${index === breadcrumbs.length - 1 ? "font-medium text-secondary" : "hover:text-gray-300 whitespace-nowrap hover:underline"}`}
                >
                  {index === 0 ? (
                    <FaHome color="#F7AF0C" fontSize="1.25rem" />
                  ) : null}
                  <span className="text-center capitalize whitespace-nowrap ">
                    {t(`navTranslate.${item.label}`)}
                  </span>
                </Link>
                {index < breadcrumbs.length - 1 && (
                  <GrFormNext color="#75B129" />
                )}
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
};

export default HeroBanner;
